module.exports = __webpack_public_path__ + "429a2290bffcc762c8bc64ae4578a245.svg";